import { defineSoldOnlyAdapter } from "../shared/sold-only.ts";
import { BARRY_PLANT_META } from "./meta.ts";
import { parseBarryPlantDetailHtml } from "./parser.ts";
import {
  barryPlantDiscoveryCacheKey,
  buildPaginatedUrl,
  buildSearchUrl,
  parseBarryPlantDiscoveryPreviews,
} from "./runtime.ts";

export * from "./meta.ts";
export * from "./parser.ts";
export * from "./runtime.ts";

export const BARRY_PLANT_ADAPTER = defineSoldOnlyAdapter(BARRY_PLANT_META, buildSearchUrl, {
  parseDetailHtml: parseBarryPlantDetailHtml,
  // Direct fetch served its search and detail pages in full (probe, 2026-10-14).
  directFirst: true,
  // Slow under load (12-month sold sitemap ~2 MB); 30 s timed out during backfills.
  directTimeoutMs: 90_000,
  // Discovery reads the sold sitemap (every sale of the last 12 months), not the 12-card search page.
  buildPaginatedUrl,
  parseDiscoveryPreviews: parseBarryPlantDiscoveryPreviews,
  discoveryCacheKey: barryPlantDiscoveryCacheKey,
});
